/* =========================================================
   PELCARE SKIN LAB™
   Quiz, subscription, analysis, results and Shopify cart
========================================================= */

(function () {
  'use strict';

  const QUESTION_BANK = {
    name:{ id:'name', type:'text', eyebrow:'SENİ TANIYALIM', title:'Sana nasıl hitap edelim?', description:'Skin Signature sonucunda adını kullanacağız.', placeholder:'Adını yaz', visualText:'Her cilt hikâyesi kişiye özeldir.' },
    afterWash:{ id:'afterWash', type:'single', eyebrow:'İLK CİLT SİNYALİ', title:'Yüzünü yıkadıktan yaklaşık 20 dakika sonra cildin sana ne söylüyor?', description:'Herhangi bir ürün sürmeden oluşan doğal hissi düşün.', visualText:'Cildin, temizleme sonrasında denge ihtiyacını açıkça gösterir.', options:[['tight','○','Gergin ve kuru','Özellikle yanaklarda rahatlama ihtiyacı hissediyorum.'],['mixed','◐','Bölgesel olarak farklı','Yanaklar daha kuru; alın ve burun daha rahat veya parlak.'],['balanced','◇','Rahat ve dengeli','Belirgin kuruluk ya da parlama olmuyor.'],['shiny','◉','Parlama başlıyor','Kısa sürede özellikle T bölgemde parlama oluyor.'],['variable','≋','Günden güne değişiyor','Hava, dönem veya rutine göre belirgin şekilde değişiyor.']] },
    dayChange:{ id:'dayChange', type:'single', eyebrow:'GÜN İÇİNDE', title:'Günün ilerleyen saatlerinde ilk değişimi nerede fark ediyorsun?', description:'Cildinin gün içindeki davranışını düşün.', visualText:'Gün içindeki değişim, yağ ve nem dengesinin önemli bir sinyalidir.', options:[['tzone','◉','Alın ve burunda parlama','T bölgem daha hızlı yağlanıyor.'],['cheeks','○','Yanaklarda kuruluk','Gerilme veya kuru görünüm belirginleşiyor.'],['makeup','◐','Makyaj parçalanıyor','Bazı bölgelerde kuruluk, bazılarında parlama oluyor.'],['dull','✦','Mat ve yorgun görünüm','Gün ilerledikçe canlılığını kaybediyor.'],['stable','◇','Belirgin değişiklik yok','Genellikle dengeli kalıyor.']] },
    moisturizer:{ id:'moisturizer', type:'single', eyebrow:'NEM SİNYALİ', title:'Nemlendirici sürdüğünde cildin nasıl davranıyor?', description:'Ürünü sürdükten sonraki ilk birkaç saati düşün.', visualText:'Nemlendirici sonrası his, susuzluk ve doku ihtiyacını ayırmamıza yardım eder.', options:[['drinks','○','Hemen emiyor','Kısa süre sonra yeniden nem ihtiyacı hissediyorum.'],['comfortable','◇','Uzun süre rahat','Nem dengem çoğunlukla korunuyor.'],['heavy','◉','Yüzeyde kalıyor','Bazı kremler ağır veya yağlı hissettiriyor.'],['mixed','◐','Bölgelere göre değişiyor','Yanaklar severken T bölgem ağır hissedebiliyor.']] },
    reaction:{ id:'reaction', type:'single', eyebrow:'REAKSİYON EĞİLİMİ', title:'Cildin yeni bir ürünle tanıştığında genellikle nasıl tepki verir?', description:'Yanma, batma, kızarma veya rahatsızlık deneyimini düşün.', visualText:'Hassasiyet, ürün seçiminde içerik kadar doku tercihini de etkiler.', options:[['fast','!','Kolay tepki verir','Kızarıklık, batma veya yanma yaşayabiliyorum.'],['sometimes','△','Bazen tepki verir','Bazı aktiflerde veya dönemlerde hassaslaşıyor.'],['rare','◇','Nadiren','Çoğu ürünü rahat kullanabiliyorum.'],['unknown','?','Emin değilim','Belirgin bir örüntü fark etmedim.']] },
    sensitivityTrigger:{ id:'sensitivityTrigger', type:'single', eyebrow:'DERİNLEŞTİRME · HASSASİYET', title:'Hassasiyet en çok ne zaman ortaya çıkıyor?', description:'Bu soru yalnızca verdiğin önceki cevaba göre açıldı.', visualText:'Skin Lab soruları cevaplarına göre değişir.', branch:true, options:[['actives','△','Aktif ürünlerden sonra','Asit, retinoid veya güçlü içeriklerden sonra.'],['weather','☼','Hava değişimlerinde','Soğuk, sıcak veya rüzgârla artıyor.'],['always','!','Sık ve öngörülemez','Belirgin bir sebep olmadan da oluşabiliyor.'],['stress','◐','Stres ve uykusuzlukta','Yoğun dönemlerde daha çok fark ediyorum.']] },
    pores:{ id:'pores', type:'single', eyebrow:'DOKU & GÖZENEK', title:'Gözenek ve tıkanma görünümünü nasıl tarif edersin?', description:'Özellikle burun, çene ve alın bölgesini düşün.', visualText:'Gözenek görünümü tek başına yağlı cilt anlamına gelmez.', options:[['frequent','◉','Belirgin ve sık tıkanan','Siyah nokta veya kapalı komedon sık oluyor.'],['visible','◐','Belirgin ama sakin','Gözenekler görünüyor fakat sık sivilce olmuyor.'],['occasional','◇','Dönemsel','Bazen tıkanma veya birkaç sivilce oluyor.'],['minimal','○','Çok az','Gözenek veya tıkanma önceliğim değil.']] },
    breakoutPattern:{ id:'breakoutPattern', type:'single', eyebrow:'DERİNLEŞTİRME · DENGE', title:'Tıkanma veya sivilce en çok hangi durumda artıyor?', description:'Bu soru yalnızca gözenek/tıkanma sinyalin nedeniyle açıldı.', visualText:'Tetikleyiciyi anlamak rutini gereksiz yere sertleştirmemizi önler.', branch:true, options:[['constant','◉','Sürekli','Çoğu zaman birkaç aktif bölge oluyor.'],['cycle','◔','Dönemsel','Belirli dönemlerde artıyor.'],['products','△','Bazı ürünlerle','Ağır ürünlerden sonra artabiliyor.'],['stress','≋','Stres/uykusuzlukta','Yoğun dönemlerde belirginleşiyor.']] },
    tone:{ id:'tone', type:'single', eyebrow:'TON & IŞILTI', title:'Aynaya baktığında cilt tonunda en çok ne dikkatini çekiyor?', description:'Makyajsız ve doğal ışıkta nasıl göründüğünü düşün.', visualText:'Işıltı ve ton görünümü bakım önceliğini şekillendirir.', options:[['even','◇','Eşit ve canlı','Ton görünümü genel olarak dengeli.'],['dull','✦','Mat ve yorgun','Daha canlı bir görünüm istiyorum.'],['spots','◐','Leke/iz görünümü','Bazı bölgelerde renk farklılıkları dikkat çekiyor.'],['red','♧','Kızarıklık','Ton eşitsizliği daha çok kızarıklıktan geliyor.']] },
    lines:{ id:'lines', type:'single', eyebrow:'CİLT DEĞİŞİMİ', title:'Son birkaç yılda cildinde hangi değişimi daha çok fark ettin?', description:'Yaş sormak yerine cildinin verdiği sinyali anlamak istiyoruz.', visualText:'Bakım ihtiyacı takvim yaşından çok cildin davranışıyla ilgilidir.', options:[['none','◇','Büyük bir değişiklik yok','Mevcut dengemi korumak istiyorum.'],['drying','○','Daha kolay kuruyor','Eskisine göre daha fazla nem ihtiyacı hissediyorum.'],['lines','∞','İnce çizgiler','Özellikle göz ve mimik bölgelerinde fark ediyorum.'],['tone','✦','Ton değişimleri','Leke veya matlık daha görünür hale geldi.'],['sensitive','♧','Daha hassas','Eskisine göre daha kolay tepki veriyor.']] },
    sun:{ id:'sun', type:'single', eyebrow:'GÜNLÜK KORUMA', title:'Güneş koruyucu gerçek hayatında ne kadar yer tutuyor?', description:'İdeal olanı değil, çoğu gün yaptığını seç.', visualText:'Gündüz koruması, hedeflediğimiz bakım sonucunun temel parçasıdır.', options:[['daily','☼','Her gün','Mevsim fark etmeksizin kullanıyorum.'],['sometimes','◐','Çoğu dışarı çıktığım gün','Düzenli ama her gün değil.'],['summer','○','Daha çok yazın','Yaz ve tatil dönemlerinde kullanıyorum.'],['never','×','Neredeyse hiç','Günlük rutinimde yer almıyor.']] },
    environment:{ id:'environment', type:'single', eyebrow:'SKIN LIFESTYLE', title:'Cildin günün büyük bölümünü hangi ortamda geçiriyor?', description:'Çevresel koşullar rutinin doku ve destek seviyesini etkileyebilir.', visualText:'Cilt yalnızca ürünlerden değil, gün boyunca bulunduğu ortamdan da etkilenir.', options:[['indoor','⌂','Kapalı/klimalı ortam','Ofis, ev veya klima altında uzun zaman geçiriyorum.'],['city','◇','Şehir içinde hareketli','Dış ortam ve şehir koşullarına sık maruz kalıyorum.'],['outdoor','☼','Açık havada','Güneş ve dış ortamda uzun süre kalıyorum.'],['mixed','◐','Karışık','Günüm kapalı ve açık alanlar arasında geçiyor.']] },
    routine:{ id:'routine', type:'single', eyebrow:'MEVCUT RİTÜEL', title:'Şu anda bakım rutinin sana ne kadar yakın?', description:'Sürdürülebilir bir öneri oluşturmak için mevcut alışkanlığını bilmek istiyoruz.', visualText:'En iyi rutin, hayatına gerçekten uyabilen rutindir.', options:[['none','○','Düzenli rutinim yok','Nereden başlayacağımı netleştirmek istiyorum.'],['minimal','1','1–2 adım','Temizleme ve/veya nemlendirme gibi temel adımlar.'],['basic','2','Temel rutin','Temizleme, nem ve SPF çoğunlukla var.'],['advanced','3','Aktif ürünler kullanıyorum','Serum ve hedefe yönelik ürünlere alışığım.']] },
    goal:{ id:'goal', type:'single', eyebrow:'RİTÜEL TERCİHİ', title:'Yeni rutinin hayatına nasıl otursun?', description:'Ürün sayısını değil, sürdürebileceğin bakım şeklini seç.', visualText:'Skin Lab öneriyi yalnızca cildine değil, ritmine de uyarlar.', options:[['simple','◇','Kısa ve net','Az adımlı, her gün uygulayabileceğim bir rutin.'],['targeted','✦','Hedefe yönelik','Ana ihtiyacıma odaklanan güçlü bir rutin.'],['complete','∞','Tam ritüel','Sabah ve akşam daha kapsamlı bakım.']] }
  };
  Object.values(QUESTION_BANK).forEach(q => { if(q.options) q.options=q.options.map(o=>({value:o[0],icon:o[1],title:o[2],description:o[3]})); });


  const ANALYSIS_MESSAGES = [
    'Nem dengesi değerlendiriliyor.',
    'Cilt bariyeri analiz ediliyor.',
    'Hassasiyet eğilimi inceleniyor.',
    'Yaşam tarzı etkileri hesaplanıyor.',
    'Kişisel bakım ritüelin hazırlanıyor.'
  ];

  class PelcareSkinLab {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId || '';
      this.config = (window.PelcareSkinLabConfig || {})[this.sectionId] || {};
      this.answers = {};
      this.currentQuestion = 0;
      this.questionPath = [];
      this.analysisMethod = 'guided';
      this.photoFile = null;
      this.photoSignals = null;
      this.analysisTimers = [];
      this.toastTimer = null;
      this.isAddingToCart = false;

      this.screens = root.querySelectorAll('[data-screen]');
      this.questionContainer = root.querySelector('[data-question-container]');
      this.nextButton = root.querySelector('[data-action="next"]');
      this.backButton = root.querySelector('[data-action="back"]');
      this.progressLabel = root.querySelector('[data-progress-label]');
      this.progressPercent = root.querySelector('[data-progress-percent]');
      this.progressBar = root.querySelector('[data-progress-bar]');
      this.dynamicVisualText = root.querySelector('[data-dynamic-visual-text]');
      this.analysisItems = Array.from(root.querySelectorAll('[data-analysis-item]'));
      this.analysisMessage = root.querySelector('[data-analysis-message]');
      this.emailForm = root.querySelector('form[action*="contact"], form[action*="customer"]');
      this.emailInput = root.querySelector('[data-email-input]');
      this.emailError = root.querySelector('[data-email-error]');
      this.emailSubmit = root.querySelector('[data-email-submit]');
      this.consentCheckbox = root.querySelector('[data-email-consent], input[name="contact[accepts_marketing]"], input[type="checkbox"]');
      this.toast = root.querySelector('[data-toast]');
      this.photoInput = root.querySelector('[data-photo-input]');
      this.photoPreview = root.querySelector('[data-photo-preview]');
      this.photoStatus = root.querySelector('[data-photo-status]');
      this.photoContinue = root.querySelector('[data-action="photo-continue"]');

      this.bindEvents();
      this.renderQuestion();
    }

    bindEvents() {
      this.root.addEventListener('click', (event) => {
        const action = event.target.closest('[data-action]');
        const option = event.target.closest('[data-option-value]');
        const productButton = event.target.closest('[data-add-product]');
        const heroButton = event.target.closest('[data-hero-add]');
        if (option) this.selectOption(option.dataset.optionValue);
        if (productButton) {
          event.preventDefault();
          this.addSingleProduct(productButton);
          return;
        }
        if (heroButton) {
          event.preventDefault();
          this.addHeroProduct(heroButton);
          return;
        }
        if (!action) return;
        const name = action.dataset.action;
        if (name === 'start' || name === 'choose-method') this.showScreen('method');
        if (name === 'guided-method') { this.analysisMethod='guided'; this.answers.analysisMethod='guided'; this.startQuiz(); }
        if (name === 'photo-method') { this.analysisMethod='photo'; this.answers.analysisMethod='photo'; this.showScreen('photo'); }
        if (name === 'photo-continue') this.continueFromPhoto();
        if (name === 'method-back') this.showScreen('method');
        if (name === 'next') this.goNext();
        if (name === 'back') this.goBack();
        if (name === 'email-back') this.showScreen('quiz');
        if (name === 'restart') this.restart();
        if (name === 'add-product') this.addSingleProduct(action);
        if (name === 'add-all') this.addAllProducts();
      });

      this.root.addEventListener('input', (event) => {
        if (event.target.matches('[data-name-input]')) {
          this.answers.name = event.target.value.trim();
          this.updateNextButton();
        }
        if (event.target.matches('[data-email-input]')) this.clearEmailError();
      });

      if (this.photoInput) this.photoInput.addEventListener('change', (event) => this.handlePhoto(event));

      if (this.emailForm) {
        /* Shopify customer formunun sayfayı yenilemesini tamamen engelle. */
        this.emailForm.addEventListener('submit', (event) => this.handleEmailSubmit(event), true);

        if (this.emailSubmit) {
          this.emailSubmit.type = 'button';
          this.emailSubmit.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.handleEmailSubmit(event);
          });
        }

        if (this.consentCheckbox) {
          this.consentCheckbox.required = true;
          this.consentCheckbox.setAttribute('aria-required', 'true');
          this.consentCheckbox.addEventListener('change', () => this.clearEmailError());
        }

        if (this.emailInput) {
          this.emailInput.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              event.stopPropagation();
              this.handleEmailSubmit(event);
            }
          });
        }
      }
    }

    showScreen(name) {
      this.screens.forEach(screen => screen.classList.toggle('is-active', screen.dataset.screen === name));
      const target = this.root.querySelector(`[data-screen="${name}"]`);
      if (target) target.scrollIntoView({ block:'start' });
    }

    startQuiz() {
      this.currentQuestion = 0;
      this.rebuildQuestionPath();
      this.renderQuestion();
      this.showScreen('quiz');
    }

    rebuildQuestionPath() {
      const a=this.answers;
      const path=['name','afterWash','dayChange'];
      const dehydrated=['tight','mixed','variable'].includes(a.afterWash) || ['cheeks','makeup'].includes(a.dayChange);
      if (dehydrated || this.analysisMethod==='guided') path.push('moisturizer');
      path.push('reaction');
      if (['fast','sometimes'].includes(a.reaction)) path.push('sensitivityTrigger');
      path.push('pores');
      if (['frequent','visible'].includes(a.pores)) path.push('breakoutPattern');
      path.push('tone','lines','sun','environment','routine','goal');
      this.questionPath=path;
      if(this.currentQuestion>=path.length) this.currentQuestion=path.length-1;
      this.deriveLegacyAnswers();
    }

    getCurrentQuestion(){ return QUESTION_BANK[this.questionPath[this.currentQuestion]]; }

    deriveLegacyAnswers(){
      const a=this.answers;
      if(a.afterWash==='tight') a.skinType='dry';
      else if(a.afterWash==='shiny' && a.dayChange==='tzone') a.skinType='oily';
      else if(a.afterWash==='mixed' || a.dayChange==='makeup') a.skinType='combination';
      else a.skinType='normal';
      if(a.reaction==='fast') a.skinType='sensitive';
      a.hydration = (a.afterWash==='tight'||a.moisturizer==='drinks')?'very_dry':((a.afterWash==='mixed'||a.dayChange==='cheeks')?'sometimes_dry':((a.afterWash==='shiny'&&a.moisturizer==='drinks')?'dehydrated_oily':'balanced'));
      a.sensitivity = a.reaction==='fast'?'frequent':a.reaction==='sometimes'?'sometimes':a.reaction==='rare'?'rare':'never';
      a.texture = ['frequent','visible'].includes(a.pores)?'pores':a.tone==='dull'?'uneven':'smooth';
      a.breakouts = a.pores==='frequent'?'frequent':a.pores==='visible'||a.pores==='occasional'?'monthly':'rare';
      if(a.tone==='spots') a.concern='dullness'; else if(a.tone==='red'||a.reaction==='fast') a.concern='redness'; else if(a.lines==='lines') a.concern='aging'; else if(a.pores==='frequent') a.concern='blemishes'; else if(['tight','mixed'].includes(a.afterWash)||a.moisturizer==='drinks') a.concern='dryness'; else a.concern='dullness';
      a.sleep = a.environment==='indoor'?'medium':'good';
      a.stress = a.sensitivityTrigger==='stress'||a.breakoutPattern==='stress'?'high':'low';
    }

    renderQuestion() {
      const question = this.getCurrentQuestion();
      if (!question || !this.questionContainer) return;
      const wrapper = document.createElement('div'); wrapper.className='psl-question__inner';
      wrapper.innerHTML=`<span class="psl-question__eyebrow">${this.escapeHTML(question.eyebrow)}</span><h2 class="psl-question__title">${this.escapeHTML(question.title)}</h2><p class="psl-question__description">${this.escapeHTML(question.description)}</p>${question.branch?'<span class="psl-question__branch-note">✦ BU SORU ÖNCEKİ CEVABINA GÖRE SEÇİLDİ</span>':''}`;
      if(question.type==='text'){const input=document.createElement('input');input.type='text';input.className='psl-name-input';input.placeholder=question.placeholder||'';input.autocomplete='given-name';input.maxLength=40;input.dataset.nameInput='';input.value=this.answers[question.id]||'';wrapper.appendChild(input);setTimeout(()=>input.focus(),100);}else{const options=document.createElement('div');options.className='psl-options';question.options.forEach(option=>{const button=document.createElement('button');button.type='button';button.className='psl-option';button.dataset.optionValue=option.value;button.classList.toggle('is-selected',this.answers[question.id]===option.value);button.innerHTML=`<span class="psl-option__icon">${this.escapeHTML(option.icon)}</span><span class="psl-option__copy"><strong>${this.escapeHTML(option.title)}</strong><small>${this.escapeHTML(option.description)}</small></span><span class="psl-option__check">✓</span>`;options.appendChild(button)});wrapper.appendChild(options)}
      this.questionContainer.replaceChildren(wrapper); if(this.dynamicVisualText)this.dynamicVisualText.textContent=question.visualText||''; this.updateProgress();this.updateNextButton();this.updateBackButton();
    }

    selectOption(value) {
      const question = this.getCurrentQuestion();
      if (!question || question.type !== 'single') return;

      this.answers[question.id] = value;

      this.questionContainer.querySelectorAll('[data-option-value]').forEach((el) => {
        el.classList.toggle('is-selected', el.dataset.optionValue === value);
        el.disabled = true;
      });

      this.rebuildQuestionPath();
      this.updateNextButton();

      clearTimeout(this.autoAdvanceTimer);
      this.autoAdvanceTimer = setTimeout(() => {
        this.goNext();
      }, 320);
    }
    hasAnswer(question){const value=this.answers[question.id];return question.type==='text'?Boolean(value&&value.trim().length>=2):Boolean(value);}
    goNext(){const question=this.getCurrentQuestion();if(!question||!this.hasAnswer(question))return;this.rebuildQuestionPath();if(this.currentQuestion<this.questionPath.length-1){this.currentQuestion+=1;this.renderQuestion();return;}this.deriveLegacyAnswers();this.showScreen(this.emailForm?'email':'analysis');if(!this.emailForm)this.startAnalysis();}
    goBack(){if(this.currentQuestion===0){this.showScreen('method');return;}this.currentQuestion-=1;this.renderQuestion();}
    updateProgress(){const current=this.currentQuestion+1,total=Math.max(this.questionPath.length,1),percent=Math.round((current/total)*100);if(this.progressLabel)this.progressLabel.textContent=`${String(current).padStart(2,'0')} / ${String(total).padStart(2,'0')}`;if(this.progressPercent)this.progressPercent.textContent=`%${percent}`;if(this.progressBar)this.progressBar.style.width=`${percent}%`;}
updateNextButton() {
  const question = this.getCurrentQuestion();
  if (!question || !this.nextButton) return;

  // Seçenekli sorularda otomatik geçiş olduğu için butonu gizle
  if (question.type === 'single') {
    this.nextButton.hidden = true;
    this.nextButton.style.display = 'none';
    return;
  }

  // İsim gibi yazı girilen sorularda Devam Et butonu görünsün
  this.nextButton.hidden = false;
  this.nextButton.style.display = '';

  this.nextButton.disabled = !this.hasAnswer(question);

  const text = this.nextButton.querySelector('span:first-child');
  if (text) {
    text.textContent = 'Devam Et';
  }
}    updateBackButton(){const text=this.backButton&&this.backButton.querySelector('span:last-child');if(text)text.textContent=this.currentQuestion===0?'Analiz yöntemi':'Geri';}

    handlePhoto(event){
      const file=event.target.files&&event.target.files[0]; if(!file)return;
      if(!/^image\/(jpeg|png|webp)$/.test(file.type)){this.photoStatus.textContent='Lütfen JPG, PNG veya WEBP yükle.';return;}
      if(file.size>10*1024*1024){this.photoStatus.textContent='Fotoğraf 10 MB’dan küçük olmalı.';return;}
      this.photoFile=file; const img=new Image(); const url=URL.createObjectURL(file);
      img.onload=()=>{const ok=img.naturalWidth>=600&&img.naturalHeight>=600;this.answers.photoQuality={width:img.naturalWidth,height:img.naturalHeight};this.photoPreview.innerHTML='';img.alt='Yüklenen selfie önizlemesi';img.src=url;this.photoPreview.appendChild(img);this.photoStatus.textContent=ok?'Fotoğraf hazır. Analize devam edebilirsin.':'Fotoğraf biraz düşük çözünürlüklü; mümkünse daha net bir fotoğraf seç.';this.photoContinue.disabled=false;}; img.src=url;
    }
    async continueFromPhoto(){
      if(!this.photoFile)return; this.photoContinue.disabled=true; this.photoStatus.textContent='Fotoğraf hazırlanıyor…';
      try{if(this.config.photoAnalysisEndpoint){const fd=new FormData();fd.append('image',this.photoFile);const res=await fetch(this.config.photoAnalysisEndpoint,{method:'POST',body:fd,credentials:'same-origin'});if(!res.ok)throw new Error('Photo analysis failed');const data=await res.json();this.photoSignals=data.signals||data;this.answers.photoSignals=this.photoSignals;this.photoStatus.textContent='Görsel sinyaller hazır.';}else{this.answers.photoUploaded=true;this.photoStatus.textContent='Fotoğraf eklendi. Görsel analiz servisi bağlanana kadar sonuç yalnızca cevaplarından oluşturulacak.';} this.startQuiz();}catch(error){console.error('PELCARE Skin Lab photo error:',error);this.answers.photoUploaded=true;this.photoStatus.textContent='Fotoğraf analizi kullanılamadı; sorularla devam ediyoruz.';this.startQuiz();}finally{this.photoContinue.disabled=false;}
    }

    async handleEmailSubmit(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      }

      if (this.isSubmittingEmail) return;

      const email = (this.emailInput ? this.emailInput.value : '').trim();
      if (!/^\S+@\S+\.\S+$/.test(email)) {
        return this.setEmailError('Lütfen geçerli bir e-posta adresi yaz.');
      }

      if (!this.consentCheckbox || !this.consentCheckbox.checked) {
        if (this.consentCheckbox) {
          this.consentCheckbox.focus();
          this.consentCheckbox.setAttribute('aria-invalid', 'true');
        }
        return this.setEmailError('Analize devam etmek için e-posta aboneliğini kabul etmelisin.');
      }

      this.consentCheckbox.removeAttribute('aria-invalid');
      this.isSubmittingEmail = true;
      const original = this.emailSubmit ? this.emailSubmit.innerHTML : '';
      if (this.emailSubmit) { this.emailSubmit.disabled = true; this.emailSubmit.innerHTML = '<span>Kaydediliyor...</span>'; }
      try {
        const body = new FormData(this.emailForm);
        const previewResult = this.calculateResult();
        const previewProfile = this.buildProfile(previewResult);
        const profileTags = [
          'newsletter',
          'skinlab',
          'pelcare-skin-lab',
          `skinlab-type-${previewProfile.skinTypeKey}`,
          `skinlab-focus-${previewProfile.primaryFocusKey}`,
          `skinlab-score-${this.scoreBand(previewResult.score)}`
        ];
        body.set('contact[email]', email);
        body.set('contact[tags]', profileTags.join(','));
        body.set('contact[accepts_marketing]', 'true');
        body.set('customer[accepts_marketing]', 'true');

        const response = await fetch(this.emailForm.action, {
          method:'POST',
          body,
          credentials:'same-origin',
          headers:{ 'X-Requested-With':'XMLHttpRequest' }
        });

        if (!response.ok) {
          throw new Error(`Shopify subscription request failed: ${response.status}`);
        }
        this.answers.email = email;
        this.startAnalysis();
      } catch (error) {
        console.error('PELCARE Skin Lab email error:', error);
        this.setEmailError('E-posta kaydedilemedi. Sonucunu yine de gösteriyoruz.');
        setTimeout(() => this.startAnalysis(), 700);
      } finally {
        this.isSubmittingEmail = false;
        if (this.emailSubmit) { this.emailSubmit.disabled = false; this.emailSubmit.innerHTML = original; }
      }
    }

    setEmailError(message) { if (this.emailError) this.emailError.textContent = message; }
    clearEmailError() { this.setEmailError(''); }

    startAnalysis() {
      this.clearAnalysisTimers(); this.resetAnalysisItems(); this.showScreen('analysis');
      let delay = 250;
      this.analysisItems.forEach((item, index) => {
        this.analysisTimers.push(setTimeout(() => {
          item.classList.add('is-active');
          const state = item.querySelector('.psl-analysis-item__state'); if (state) state.textContent = 'Analiz ediliyor';
          if (this.analysisMessage) this.analysisMessage.textContent = ANALYSIS_MESSAGES[index] || 'Analizin hazırlanıyor.';
        }, delay));
        delay += 550;
        this.analysisTimers.push(setTimeout(() => {
          item.classList.remove('is-active'); item.classList.add('is-complete');
          const state = item.querySelector('.psl-analysis-item__state'); if (state) state.textContent = 'Tamamlandı';
        }, delay));
        delay += 180;
      });
      this.analysisTimers.push(setTimeout(() => { this.renderResults(); this.showScreen('result'); }, delay + 250));
    }

    resetAnalysisItems() {
      this.analysisItems.forEach(item => { item.classList.remove('is-active','is-complete'); const state = item.querySelector('.psl-analysis-item__state'); if (state) state.textContent = 'Bekliyor'; });
      if (this.analysisMessage) this.analysisMessage.textContent = ANALYSIS_MESSAGES[0];
    }

    clearAnalysisTimers() { this.analysisTimers.forEach(clearTimeout); this.analysisTimers = []; }

    calculateResult() {
      let hydration = 78;
      let barrier = 80;
      let radiance = 76;
      let sensitivity = 78;
      let oilBalance = 78;
      const a = this.answers;

      if (a.skinType === 'dry') { hydration -= 18; barrier -= 9; oilBalance += 7; }
      if (a.skinType === 'oily') { hydration -= 6; barrier -= 4; radiance -= 3; oilBalance -= 18; }
      if (a.skinType === 'combination') { hydration -= 9; barrier -= 4; oilBalance -= 10; }
      if (a.skinType === 'sensitive') { barrier -= 13; sensitivity -= 20; }

      if (a.hydration === 'very_dry') { hydration -= 24; barrier -= 11; radiance -= 8; }
      if (a.hydration === 'sometimes_dry') { hydration -= 12; barrier -= 5; }
      if (a.hydration === 'dehydrated_oily') { hydration -= 17; barrier -= 8; oilBalance -= 8; }
      if (a.hydration === 'balanced') { hydration += 7; barrier += 4; }

      if (a.sensitivity === 'frequent') { sensitivity -= 28; barrier -= 15; }
      if (a.sensitivity === 'sometimes') { sensitivity -= 14; barrier -= 7; }
      if (a.sensitivity === 'never') { sensitivity += 8; barrier += 3; }

      if (a.concern === 'dryness') hydration -= 10;
      if (a.concern === 'dullness') radiance -= 16;
      if (a.concern === 'aging') { radiance -= 8; hydration -= 6; }
      if (a.concern === 'blemishes') { barrier -= 7; radiance -= 7; oilBalance -= 12; }
      if (a.concern === 'redness') { sensitivity -= 13; barrier -= 8; }

      if (a.texture === 'rough') { hydration -= 7; radiance -= 8; }
      if (a.texture === 'pores') { radiance -= 5; oilBalance -= 9; }
      if (a.texture === 'uneven') { radiance -= 10; barrier -= 4; }

      if (a.breakouts === 'frequent') { barrier -= 10; radiance -= 6; oilBalance -= 15; }
      if (a.breakouts === 'monthly') { barrier -= 5; oilBalance -= 7; }

      if (a.sun === 'daily') { radiance += 8; barrier += 3; }
      if (a.sun === 'summer') radiance -= 7;
      if (a.sun === 'never') { radiance -= 17; barrier -= 7; }

      if (a.sleep === 'medium') { radiance -= 6; hydration -= 3; }
      if (a.sleep === 'low') { radiance -= 12; hydration -= 7; barrier -= 4; }
      if (a.stress === 'medium') { sensitivity -= 5; barrier -= 3; }
      if (a.stress === 'high') { sensitivity -= 12; barrier -= 8; radiance -= 6; }

      if (a.routine === 'basic') barrier += 3;
      if (a.routine === 'advanced') { hydration += 5; barrier += 4; radiance += 5; }
      if (a.routine === 'none') { hydration -= 6; barrier -= 7; radiance -= 5; }

      /* Optional server-side visual signals. Expected normalized 0..1 confidence values. */
      const ps=a.photoSignals||{};
      const n=(v)=>Number.isFinite(Number(v))?this.clamp(Number(v),0,1):null;
      if(n(ps.redness)!=null){ sensitivity -= Math.round(n(ps.redness)*12); barrier -= Math.round(n(ps.redness)*5); }
      if(n(ps.shine)!=null){ oilBalance -= Math.round(n(ps.shine)*10); }
      if(n(ps.visible_pores)!=null){ oilBalance -= Math.round(n(ps.visible_pores)*7); radiance -= Math.round(n(ps.visible_pores)*3); }
      if(n(ps.uneven_tone)!=null){ radiance -= Math.round(n(ps.uneven_tone)*10); }

      hydration = this.clamp(hydration, 35, 96);
      barrier = this.clamp(barrier, 35, 96);
      radiance = this.clamp(radiance, 35, 96);
      sensitivity = this.clamp(sensitivity, 35, 96);
      oilBalance = this.clamp(oilBalance, 35, 96);

      const score = Math.round(
        (hydration + barrier + radiance + sensitivity + oilBalance) / 5
      );

      return { hydration, barrier, radiance, sensitivity, oilBalance, score };
    }

    scoreBand(score) {
      if (score >= 85) return 'excellent';
      if (score >= 72) return 'good';
      if (score >= 58) return 'developing';
      return 'needs-support';
    }

    renderResults() {
      const result = this.calculateResult();
      const profile = this.buildProfile(result);

      this.lastResult = result;
      this.lastProfile = profile;

      this.setText('[data-result-name]', this.answers.name || 'Merhaba');
      this.setText('[data-story-name]', this.answers.name ? `${this.answers.name}'in cildi` : 'Cildin');
      this.setText('[data-score]', result.score);
      this.setText('[data-score-label]', profile.scoreLabel);
      this.setText('[data-result-summary]', profile.summary);
      this.setText('[data-skin-story-title]', profile.storyTitle);
      this.setText('[data-skin-story]', profile.story);
      this.setText('[data-story-paragraph-one]', profile.paragraphs[0]);
      this.setText('[data-story-paragraph-two]', profile.paragraphs[1]);
      this.setText('[data-story-paragraph-three]', profile.paragraphs[2]);
      this.setText('[data-primary-focus]', profile.primaryFocus);
      this.setText('[data-story-recommendation]', profile.recommendation);

      const ring = this.root.querySelector('[data-score-ring]');
      if (ring) ring.style.setProperty('--score-angle', `${Math.round(result.score * 3.6)}deg`);

      this.renderList('[data-strengths]', profile.strengths, 'psl-result-list');
      this.renderList('[data-focus-areas]', profile.focusAreas, 'psl-result-list psl-focus-list');
      this.renderTags(profile.tags);

      ['hydration', 'barrier', 'radiance', 'sensitivity'].forEach((key) => {
        this.updateMetric(key, result[key]);
      });

      this.renderProductRecommendations(profile, result);
      this.renderPremiumExperience(profile, result);
      this.saveLocalResult(profile, result);
    }

    buildProfile(result) {
      const a = this.answers;
      const labels = {
        hydration: 'Nem dengesi',
        barrier: 'Cilt bariyeri',
        radiance: 'Aydınlık görünüm',
        sensitivity: 'Hassasiyet dengesi',
        oilBalance: 'Yağ dengesi'
      };
      const metrics = Object.keys(labels).map((key) => ({ key, label: labels[key], value: result[key] }));
      const strongest = [...metrics].sort((x, y) => y.value - x.value).slice(0, 2);
      const weakest = [...metrics].sort((x, y) => x.value - y.value).slice(0, 2);

      const skinTypes = {
        dry: ['dry', 'Kuru cilt'],
        oily: ['oily', 'Yağlı cilt'],
        combination: ['combination', 'Karma cilt'],
        normal: ['normal', 'Dengeli cilt'],
        sensitive: ['sensitive', 'Hassas cilt']
      };
      const [skinTypeKey, skinTypeLabel] = skinTypes[a.skinType] || skinTypes.normal;

      const focuses = {
        dryness: ['hydration', 'Nem ve bariyer desteği'],
        dullness: ['radiance', 'Aydınlık ve eşit ton görünümü'],
        aging: ['aging', 'Sıkılık ve ince çizgi bakımı'],
        blemishes: ['blemishes', 'Gözenek ve cilt dengesi'],
        redness: ['sensitivity', 'Sakinleştirici hassasiyet bakımı']
      };
      const [primaryFocusKey, primaryFocus] = focuses[a.concern] || ['barrier', 'Nem ve bariyer desteği'];

      let scoreLabel = 'Dengeye İhtiyacı Var';
      let storyTitle = 'Cildin doğru destekle daha dengeli hale gelebilir.';
      if (result.score >= 85) { scoreLabel = 'Çok İyi Denge'; storyTitle = 'Cildin güçlü ve dengeli bir yapıya sahip.'; }
      else if (result.score >= 72) { scoreLabel = 'İyi Denge'; storyTitle = 'Cildin güçlü bir temele sahip.'; }
      else if (result.score >= 58) { scoreLabel = 'Gelişen Denge'; storyTitle = 'Cildin bazı alanlarda hedefli desteğe ihtiyaç duyuyor.'; }

      const strengthText = {
        hydration: 'Cildin nemi tutma konusunda iyi bir temele sahip.',
        barrier: 'Cilt bariyerin çevresel etkilere karşı dengeli görünüyor.',
        radiance: 'Cildin doğal canlılığını ve aydınlık görünümünü koruyor.',
        sensitivity: 'Cildin hassasiyet belirtilerini genel olarak iyi yönetiyor.',
        oilBalance: 'Cildinin yağ dengesi genel olarak kontrollü görünüyor.'
      };
      const focusText = {
        hydration: 'Yoğun nem ve su kaybını azaltan bariyer desteğine odaklan.',
        barrier: 'Nazik temizleme ve onarıcı bakım adımlarını güçlendir.',
        radiance: 'Antioksidan ve aydınlatıcı içerikleri rutinine ekle.',
        sensitivity: 'Sakinleştirici içeriklerle cilt hassasiyetini dengede tut.',
        oilBalance: 'Cildi kurutmadan arındıran ve sebumu dengeleyen ürünleri seç.'
      };

      const lifestyleNotes = [];
      if (a.sun !== 'daily') lifestyleNotes.push('günlük güneş koruması');
      if (a.sleep === 'low' || a.sleep === 'medium') lifestyleNotes.push('daha düzenli uyku');
      if (a.stress === 'high') lifestyleNotes.push('stres kaynaklı hassasiyeti azaltan sade bakım');
      const lifestyle = lifestyleNotes.length ? lifestyleNotes.join(', ') : 'mevcut dengeli alışkanlıklarını sürdürmek';

      const tags = [skinTypeLabel, primaryFocus];
      if (a.hydration === 'very_dry' || a.hydration === 'dehydrated_oily') tags.push('Susuzluk eğilimi');
      if (a.sensitivity === 'frequent' || a.sensitivity === 'sometimes') tags.push('Hassasiyet eğilimi');
      if (a.breakouts === 'frequent' || a.breakouts === 'monthly') tags.push('Tıkanma eğilimi');

      return {
        skinTypeKey,
        skinTypeLabel,
        primaryFocusKey,
        primaryFocus,
        scoreLabel,
        storyTitle,
        summary: `Yanıtlarına göre cilt profilin ${skinTypeLabel.toLocaleLowerCase('tr-TR')} özellikleri gösteriyor. Öncelikli bakım odağın ${primaryFocus.toLocaleLowerCase('tr-TR')}.`,
        story: `En güçlü alanın ${strongest[0].label.toLocaleLowerCase('tr-TR')}; öncelikli destek alanın ise ${weakest[0].label.toLocaleLowerCase('tr-TR')}. Düzenli ve nazik bir rutinle cildinin dengesini güçlendirebilirsin.`,
        paragraphs: [
          `Cildin çoğu zaman ${skinTypeLabel.toLocaleLowerCase('tr-TR')} özellikleri gösteriyor ve özellikle ${primaryFocus.toLocaleLowerCase('tr-TR')} konusunda hedefli desteğe ihtiyaç duyuyor.`,
          `Nem, bariyer, aydınlık görünüm, hassasiyet ve yağ dengesi birlikte değerlendirildiğinde en güçlü alanın ${strongest[0].label.toLocaleLowerCase('tr-TR')}; geliştirilmesi gereken alanın ${weakest[0].label.toLocaleLowerCase('tr-TR')} olarak öne çıkıyor.`,
          `Bakım rutininin etkisini güçlendirmek için ${lifestyle} ve ürünleri düzenli kullanmak önemli.`
        ],
        recommendation: `${this.routineDepthLabel()} bir rutinle önce cildi nazikçe temizle, ardından ${primaryFocus.toLocaleLowerCase('tr-TR')} odaklı bakım uygula ve gündüz rutininin son adımında mutlaka güneş koruyucu kullan.`,
        strengths: strongest.map((m) => strengthText[m.key]),
        focusAreas: weakest.map((m) => focusText[m.key]),
        tags: tags.slice(0, 4)
      };
    }

    routineDepthLabel() {
      if (this.answers.goal === 'simple') return 'Sade ve sürdürülebilir';
      if (this.answers.goal === 'complete') return 'Sabah ve akşam eksiksiz';
      return 'Hedefe yönelik';
    }

    renderTags(tags) {
      const container = this.root.querySelector('[data-story-tags]');
      if (!container) return;
      container.replaceChildren(...tags.map((tag) => {
        const span = document.createElement('span');
        span.textContent = tag;
        return span;
      }));
    }

    renderProductRecommendations(profile, result) {
      const grid = this.root.querySelector('.psl-product-grid');
      if (!grid) return;
      const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
      if (!cards.length) return;

      const ranked = cards.map((card) => {
        const title = (card.querySelector('h4')?.textContent || '').trim();
        const reason = (card.querySelector('p')?.textContent || '').trim();
        const score = this.scoreProduct(title, reason, profile);
        return { card, title, score };
      }).sort((x, y) => y.score - x.score);

      const visibleCount = this.answers.goal === 'simple' ? 3 : Math.min(4, ranked.length);
      ranked.forEach((item, index) => {
        item.card.hidden = index >= visibleCount;
        item.card.dataset.recommendationRank = String(index + 1);
        item.card.dataset.match = String(this.clamp(82 + item.score, 82, 98));
        grid.appendChild(item.card);
        this.decorateProductCard(item.card, item, index);
      });

      const selected = ranked.slice(0, visibleCount);
      this.recommendedCards = selected.map((item) => item.card);
      this.renderHeroProduct(selected[0], profile, result);
      this.updateRitualSummary(selected.length);
    }

    scoreProduct(title, reason, profile) {
      const text = `${title} ${reason}`.toLocaleLowerCase('tr-TR');
      const a = this.answers;
      let score = 0;
      const has = (...words) => words.some((word) => text.includes(word));

      if (has('cleanser', 'cleanser', 'temizleyici', 'supergreen')) score += 8;
      if (has('sunscreen', 'spf', 'güneş')) score += a.sun === 'daily' ? 8 : 22;
      if (has('repair', 'repairing', 'plumping', 'onarıcı', 'superfood repairing')) score += (a.concern === 'dryness' || a.hydration !== 'balanced') ? 25 : 10;
      if (has('brightening', 'glow', 'aydınlat', 'antioxidant', 'saffron')) score += (a.concern === 'dullness' || a.concern === 'aging') ? 25 : 9;
      if (has('soothing', 'calming', 'cannabis', 'sakin', 'hassas')) score += (a.concern === 'redness' || a.sensitivity !== 'never') ? 28 : 6;
      if (has('oil', 'yağ')) score += a.concern === 'aging' ? 18 : 5;
      if (has('eye', 'göz')) score += (a.concern === 'aging' || a.sleep !== 'good') ? 15 : 4;
      if (has('serum')) score += a.goal === 'targeted' || a.goal === 'complete' ? 9 : 3;
      if (has('cream', 'krem', 'moistur')) score += a.hydration !== 'balanced' ? 14 : 7;
      if (a.skinType === 'oily' && has('butter', 'yoğun')) score -= 7;
      if (profile.primaryFocusKey === 'blemishes' && has('cleanser', 'supergreen', 'serum')) score += 8;
      return score;
    }

    decorateProductCard(card, item, index) {
      let match = card.querySelector('[data-product-match]');
      if (!match) {
        match = document.createElement('span');
        match.dataset.productMatch = '';
        match.className = 'psl-product-card__match';
        const content = card.querySelector('.psl-product-card__content');
        if (content) content.prepend(match);
      }
      match.textContent = `%${card.dataset.match} eşleşme`;

      const routineLabel = card.querySelector('.psl-product-card__content > span:not([data-product-match])');
      if (routineLabel) routineLabel.textContent = this.inferProductUsage(item.title);

      if (index === 0) card.classList.add('is-top-match');
      else card.classList.remove('is-top-match');
    }

    inferProductUsage(title) {
      const text = title.toLocaleLowerCase('tr-TR');
      if (text.includes('sunscreen') || text.includes('spf') || text.includes('güneş')) return 'Sabah · Son adım';
      if (text.includes('cleanser') || text.includes('temizleyici')) return 'Sabah ve Akşam · 1. adım';
      if (text.includes('oil') || text.includes('yağ')) return 'Akşam · Son bakım adımı';
      return 'Sabah ve Akşam';
    }

    renderHeroProduct(item, profile) {
      const section = this.root.querySelector('[data-hero-product]');
      if (!section || !item) return;
      const card = item.card;
      const image = card.querySelector('img');
      const title = item.title;
      const description = (card.querySelector('.psl-product-card__content p')?.textContent || '').trim();
      const price = (card.querySelector('.psl-product-card__content strong')?.textContent || '').trim();
      const variantId = Number(card.dataset.productId);

      section.hidden = false;
      section.dataset.productId = String(variantId || '');
      this.setText('[data-hero-match]', `${card.dataset.match}%`);
      this.setText('[data-hero-title]', title);
      this.setText('[data-hero-description]', description || `${profile.primaryFocus} ihtiyacını desteklemek için seçildi.`);
      this.setText('[data-hero-price]', price);
      this.setText('[data-hero-usage]', this.inferProductUsage(title));
      this.setText('[data-hero-step]', this.inferProductStep(title));

      const heroImage = section.querySelector('[data-hero-image]');
      if (heroImage && image) {
        heroImage.src = image.currentSrc || image.src;
        heroImage.alt = title;
      }

      const reasons = section.querySelector('[data-hero-reasons]');
      if (reasons) {
        const values = [
          `${profile.primaryFocus} ihtiyacınla güçlü şekilde eşleşir.`,
          `${profile.skinTypeLabel} özelliklerine uygun bir bakım adımıdır.`,
          'Günlük ritüele kolayca eklenebilir ve düzenli kullanıma uygundur.'
        ];
        reasons.replaceChildren(...values.map((value) => {
          const li = document.createElement('li');
          li.innerHTML = `<span aria-hidden="true">✓</span>${this.escapeHTML(value)}`;
          return li;
        }));
      }

      const button = section.querySelector('[data-hero-add]');
      if (button) button.disabled = !variantId;
    }

    inferProductStep(title) {
      const text = title.toLocaleLowerCase('tr-TR');
      if (text.includes('cleanser') || text.includes('temizleyici')) return 'Temizleme';
      if (text.includes('sunscreen') || text.includes('spf') || text.includes('güneş')) return 'Koruma';
      if (text.includes('serum')) return 'Serum';
      if (text.includes('oil') || text.includes('yağ')) return 'Bakım yağı';
      if (text.includes('eye') || text.includes('göz')) return 'Göz çevresi';
      return 'Nemlendirme';
    }

    updateRitualSummary(count) {
      const countElement = this.root.querySelector('.psl-complete-ritual__product-count');
      if (countElement) countElement.textContent = `${count} ürün`;
    }

    saveLocalResult(profile, result) {
      try {
        localStorage.setItem('pelcareSkinLabResult', JSON.stringify({
          createdAt: new Date().toISOString(),
          email: this.answers.email || '',
          answers: this.answers,
          profile,
          result
        }));
      } catch (error) {
        console.warn('PELCARE Skin Lab local result could not be saved.', error);
      }
    }

    renderList(selector, items, className) {
      const container=this.root.querySelector(selector); if(!container)return;
      const list=document.createElement('ul'); list.className=className;
      items.forEach(text=>{const li=document.createElement('li');li.textContent=text;list.appendChild(li);});
      container.replaceChildren(list);
    }

    updateMetric(metric,value) {
      this.setText(`[data-metric-value="${metric}"]`, value);
      const bar=this.root.querySelector(`[data-metric-bar="${metric}"]`); if(!bar)return;
      bar.style.width='0%'; requestAnimationFrame(()=>setTimeout(()=>{bar.style.width=`${value}%`;},120));
    }

    renderPremiumExperience(profile, result) {
      this.ensurePremiumSections();
      this.renderPremiumScore(profile, result);
      this.renderIngredientIntelligence(profile, result);
      this.renderRoutinePlan(profile);
      this.activateRevealAnimations();
    }

    ensurePremiumSections() {
      const story = this.root.querySelector('[data-skin-story-section]');
      if (!story || this.root.querySelector('[data-premium-insights]')) return;

      const section = document.createElement('section');
      section.className = 'psl-premium-insights';
      section.dataset.premiumInsights = '';
      section.innerHTML = `
        <div class="psl-premium-score psl-reveal">
          <div class="psl-premium-score__main">
            <span class="psl-eyebrow">SKIN SCORE</span>
            <div class="psl-premium-score__number">
              <strong data-premium-score>0</strong><span>/100</span>
            </div>
            <h3 data-premium-score-title>Cilt dengen değerlendiriliyor.</h3>
            <p data-premium-score-copy></p>
          </div>
          <div class="psl-premium-score__metrics" data-premium-metrics></div>
        </div>

        <div class="psl-intelligence-grid">
          <article class="psl-intelligence-card psl-reveal">
            <span class="psl-eyebrow">INGREDIENT INTELLIGENCE</span>
            <h3>Cildinin sevdiği içerikler.</h3>
            <p>Analiz sonuçlarına göre bakım rutininde önceliklendirebileceğin botanikler ve aktifler.</p>
            <div class="psl-ingredient-list" data-ingredient-list></div>
          </article>

          <article class="psl-intelligence-card psl-intelligence-card--ai psl-reveal">
            <span class="psl-eyebrow">PELCARE INSIGHT ✦</span>
            <h3 data-ai-insight-title>Kişisel bakım içgörün.</h3>
            <p data-ai-insight-copy></p>
            <div class="psl-ai-note">Bu değerlendirme kozmetik bakım önerisidir; tıbbi tanı yerine geçmez.</div>
          </article>
        </div>

        <section class="psl-routine-plan psl-reveal">
          <div class="psl-section-heading">
            <div>
              <span class="psl-eyebrow">KİŞİSEL RİTÜEL</span>
              <h3>Sabah ve akşam bakım planın.</h3>
            </div>
            <p>Az ama doğru adımlarla, cildinin ihtiyacına göre oluşturuldu.</p>
          </div>
          <div class="psl-routine-columns">
            <article class="psl-routine-column">
              <div class="psl-routine-column__head"><span>☀</span><div><small>SABAH</small><strong>Koruyucu ritüel</strong></div></div>
              <ol data-morning-routine></ol>
            </article>
            <article class="psl-routine-column psl-routine-column--night">
              <div class="psl-routine-column__head"><span>☾</span><div><small>AKŞAM</small><strong>Yenileyici ritüel</strong></div></div>
              <ol data-evening-routine></ol>
            </article>
          </div>
        </section>`;

      story.insertAdjacentElement('afterend', section);
    }

    renderPremiumScore(profile, result) {
      const scoreEl = this.root.querySelector('[data-premium-score]');
      if (scoreEl) this.animateNumber(scoreEl, result.score, 1100);

      this.setText('[data-premium-score-title]', profile.scoreLabel);
      this.setText('[data-premium-score-copy]', `${profile.skinTypeLabel} profilinde en güçlü alanın korunurken ${profile.primaryFocus.toLocaleLowerCase('tr-TR')} odağında düzenli destek öneriliyor.`);

      const metrics = [
        ['hydration', 'Nem', result.hydration],
        ['barrier', 'Bariyer', result.barrier],
        ['radiance', 'Aydınlık', result.radiance],
        ['sensitivity', 'Hassasiyet Dengesi', result.sensitivity],
        ['oilBalance', 'Yağ Dengesi', result.oilBalance]
      ];
      const container = this.root.querySelector('[data-premium-metrics]');
      if (!container) return;
      container.innerHTML = metrics.map(([key, label, value]) => `
        <div class="psl-premium-metric">
          <div class="psl-premium-metric__top"><span>${label}</span><strong>${value}</strong></div>
          <div class="psl-premium-metric__track"><span data-premium-bar="${key}" style="--target:${value}%"></span></div>
          <small>${this.metricState(value)}</small>
        </div>`).join('');

      requestAnimationFrame(() => {
        container.querySelectorAll('[data-premium-bar]').forEach((bar) => bar.classList.add('is-filled'));
      });
    }

    metricState(value) {
      if (value >= 82) return 'Güçlü';
      if (value >= 68) return 'Dengeli';
      if (value >= 54) return 'Desteklenebilir';
      return 'Öncelikli alan';
    }

    ingredientMatches(profile) {
      const a = this.answers;
      const pool = [];
      const add = (name, benefit, score) => pool.push({ name, benefit, score });

      if (profile.primaryFocusKey === 'hydration' || a.hydration !== 'balanced') {
        add('Hyaluronic Acid', 'Yoğun nem ve dolgun görünüm', 97);
        add('Baobab', 'Bariyer ve lipid desteği', 91);
      }
      if (profile.primaryFocusKey === 'sensitivity' || a.sensitivity !== 'never') {
        add('Hemp Extract', 'Sakin ve konforlu cilt hissi', 98);
        add('Rosemary', 'Antioksidan ve yatıştırıcı bakım', 89);
      }
      if (profile.primaryFocusKey === 'radiance' || a.concern === 'dullness') {
        add('Saffron', 'Aydınlık ve eşit ton görünümü', 97);
        add('Vitamin C', 'Canlılık ve antioksidan destek', 92);
      }
      if (profile.primaryFocusKey === 'aging' || a.concern === 'aging') {
        add('Bakuchiol', 'Sıkılık ve pürüzsüz görünüm', 96);
        add('Marula Oil', 'Besleyici antioksidan bakım', 90);
      }
      if (profile.primaryFocusKey === 'blemishes' || a.breakouts === 'frequent') {
        add('Niacinamide', 'Gözenek ve sebum dengesi', 95);
        add('Willow Bark', 'Nazik arındırıcı bakım', 88);
      }
      add('Anatolian Rose', 'Nem, konfor ve doğal ışıltı', 87);

      return pool.sort((x, y) => y.score - x.score).filter((item, index, array) => array.findIndex(x => x.name === item.name) === index).slice(0, 5);
    }

    renderIngredientIntelligence(profile, result) {
      const ingredients = this.ingredientMatches(profile);
      const container = this.root.querySelector('[data-ingredient-list]');
      if (container) {
        container.innerHTML = ingredients.map((item) => `
          <div class="psl-ingredient">
            <div class="psl-ingredient__meta"><strong>${item.name}</strong><span>%${item.score} eşleşme</span></div>
            <p>${item.benefit}</p>
            <div class="psl-ingredient__track"><span style="--target:${item.score}%"></span></div>
          </div>`).join('');
        requestAnimationFrame(() => container.querySelectorAll('.psl-ingredient__track span').forEach(bar => bar.classList.add('is-filled')));
      }

      this.setText('[data-ai-insight-title]', `${profile.primaryFocus} için sade ama istikrarlı bakım.`);
      const weakest = Object.entries({ hydration:result.hydration, barrier:result.barrier, radiance:result.radiance, sensitivity:result.sensitivity, oilBalance:result.oilBalance }).sort((a,b)=>a[1]-b[1])[0][0];
      const advice = {
        hydration:'Cildin su kaybına açık görünüyor. Nem serumu ile bariyer destekli kremi katmanlamak, daha konforlu bir görünüm sağlayabilir.',
        barrier:'Cilt bariyerin rutinin ana odağı olmalı. Sert arındırmadan kaçın; az adımlı, onarıcı ve parfümsüz bakımı önceliklendir.',
        radiance:'Canlı görünümü güçlendirmek için antioksidan bakım ve günlük SPF kullanımını birlikte düşün.',
        sensitivity:'Hassasiyet eğilimi nedeniyle yeni ürünleri yavaş ekle ve sakinleştirici bakım adımlarını düzenli uygula.',
        oilBalance:'Yağ dengesini kurutmadan desteklemek önemli. Nazik temizleyici ve hafif dokulu nem bakımını birlikte kullan.'
      };
      this.setText('[data-ai-insight-copy]', advice[weakest]);
    }

    renderRoutinePlan(profile) {
      const cards = this.recommendedCards || [];
      const products = cards.map((card) => {
        const title = (card.querySelector('h4')?.textContent || 'PELCARE bakım ürünü').trim();
        return { title, step:this.inferProductStep(title), usage:this.inferProductUsage(title), match:card.dataset.match || '90' };
      });

      const cleanser = products.find(p => p.step === 'Temizleme');
      const sunscreen = products.find(p => p.step === 'Koruma');
      const treatments = products.filter(p => !['Temizleme','Koruma'].includes(p.step));
      const morning = [cleanser, ...treatments.slice(0, 2), sunscreen].filter(Boolean);
      const evening = [cleanser, ...treatments.slice(0, 3)].filter(Boolean);

      if (!morning.length) morning.push({ title:'Nazik temizleme', step:'Temizleme', match:'95' }, { title:profile.primaryFocus, step:'Hedefli bakım', match:'94' }, { title:'Günlük SPF', step:'Koruma', match:'98' });
      if (!evening.length) evening.push({ title:'Nazik temizleme', step:'Temizleme', match:'95' }, { title:profile.primaryFocus, step:'Hedefli bakım', match:'94' }, { title:'Bariyer desteği', step:'Nemlendirme', match:'92' });

      this.renderRoutineList('[data-morning-routine]', morning);
      this.renderRoutineList('[data-evening-routine]', evening);
    }

    renderRoutineList(selector, items) {
      const list = this.root.querySelector(selector);
      if (!list) return;
      list.innerHTML = items.map((item, index) => `
        <li>
          <span class="psl-routine-step">${String(index + 1).padStart(2, '0')}</span>
          <div><small>${item.step}</small><strong>${this.escapeHTML(item.title)}</strong><p>%${item.match} analiz eşleşmesi</p></div>
        </li>`).join('');
    }

    animateNumber(element, target, duration) {
      const start = performance.now();
      const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        element.textContent = String(Math.round(target * eased));
        if (progress < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }

    activateRevealAnimations() {
      const items = this.root.querySelectorAll('.psl-reveal');
      if (!('IntersectionObserver' in window)) {
        items.forEach(item => item.classList.add('is-visible'));
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold:0.13 });
      items.forEach(item => observer.observe(item));
    }

    async addHeroProduct(button) {
      const section = button.closest('[data-hero-product]');
      const id = Number(section && section.dataset.productId);
      if (!id) return this.showToast('Hero ürün seçeneği bulunamadı.');
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Ekleniyor...';
      try {
        await this.addItemsToCart([{ id, quantity: 1 }]);
        button.textContent = 'Ritüeline Eklendi ✓';
        this.showToast('Hero ürün ritüeline eklendi.');
      } catch (error) {
        console.error('PELCARE Skin Lab hero product error:', error);
        button.disabled = false;
        button.textContent = original;
        this.showToast('Ürün sepete eklenemedi.');
      }
    }

    async addSingleProduct(button) {
      const card=button.closest('[data-product-card]');
      const id=Number(button.dataset.productId || (card && card.dataset.productId));
      if(!id)return this.showToast('Bu ürün için varyant seçimi eksik.');
      const original=button.innerHTML; button.disabled=true; button.textContent='Ekleniyor...';
      try{await this.addItemsToCart([{id,quantity:1}]);button.textContent='Sepete Eklendi ✓';this.showToast('Ürün sepete eklendi.');}
      catch(error){console.error('PELCARE Skin Lab product error:',error);button.disabled=false;button.innerHTML=original;this.showToast('Ürün sepete eklenemedi.');}
    }

    async addAllProducts() {
      if(this.isAddingToCart)return;
      const cards = this.recommendedCards && this.recommendedCards.length
        ? this.recommendedCards
        : Array.from(this.root.querySelectorAll('[data-product-card]:not([hidden])'));
      const items = cards.map(card => ({ id:Number(card.dataset.productId), quantity:1 })).filter(item => item.id);
      if(!items.length)return this.showToast('Önerilen ürünler henüz seçilmedi.');
      const button=this.root.querySelector('[data-action="add-all"]'); const original=button?button.innerHTML:'';
      if(button){button.disabled=true;button.innerHTML='<span>Ritüel Ekleniyor...</span>';}
      try{await this.addItemsToCart(items);this.showToast('Kişisel bakım ritüelin sepete eklendi.');if(button)button.innerHTML='<span>Sepete Eklendi ✓</span>';const code=this.root.querySelector('[data-complete-ritual]')?.dataset.discountCode;if(code&&this.config.cartUrl)setTimeout(()=>{window.location.href=`${this.config.cartUrl}?discount=${encodeURIComponent(code)}`;},700);}
      catch(error){console.error('PELCARE Skin Lab bundle error:',error);if(button){button.disabled=false;button.innerHTML=original;}this.showToast('Ritüel sepete eklenemedi. Lütfen tekrar dene.');}
    }

    async addItemsToCart(items) {
      if(this.isAddingToCart)throw new Error('Cart operation already running.');
      this.isAddingToCart=true;
      try{const response=await fetch(this.config.cartAddUrl || '/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});if(!response.ok){const data=await response.json().catch(()=>null);throw new Error(data?.description || 'Cart request failed.');}const result=await response.json();document.dispatchEvent(new CustomEvent('pelcare:cart-updated',{detail:result}));document.dispatchEvent(new CustomEvent('cart:refresh'));return result;}finally{this.isAddingToCart=false;}
    }

    showToast(message) { if(!this.toast)return; clearTimeout(this.toastTimer); this.toast.textContent=message; this.toast.classList.add('is-visible'); this.toastTimer=setTimeout(()=>this.toast.classList.remove('is-visible'),3000); }

    restart() {
      this.clearAnalysisTimers(); this.answers={}; this.currentQuestion=0; this.questionPath=[]; this.analysisMethod='guided'; this.photoFile=null; this.photoSignals=null; this.isAddingToCart=false;
      if(this.emailForm)this.emailForm.reset(); if(this.consentCheckbox)this.consentCheckbox.removeAttribute('aria-invalid'); this.clearEmailError(); this.resetAnalysisItems(); this.renderQuestion(); this.showScreen('welcome');
    }

    setText(selector,value){const element=this.root.querySelector(selector);if(element)element.textContent=String(value);}
    clamp(value,min,max){return Math.min(Math.max(value,min),max);}
    escapeHTML(value){return String(value).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#039;');}
  }

  function initializeSkinLab(scope) {
    (scope || document).querySelectorAll('.psl[data-section-id]').forEach(root => {
      if(root.dataset.skinLabInitialized==='true')return;
      root.dataset.skinLabInitialized='true'; new PelcareSkinLab(root);
    });
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initializeSkinLab(document)); else initializeSkinLab(document);
  document.addEventListener('shopify:section:load',event=>initializeSkinLab(event.target));
})();
